import { SeatMapResponseEnum } from "@b2bportal/air-booking-api";
import { CartState, ParentState } from "@hopper-b2b/checkout";
import type { FlightMachineContext } from "../types";

export const seatsGuards = {
  hasSeatMapAvailability: (ctx: FlightMachineContext, _event: unknown) =>
    ctx[ParentState.seatSelection].seatMapAvailable ===
      SeatMapResponseEnum.SeatMapAvailable && !ctx.featureFlags.hideSeats,

  // Check if we should re-quote: cart is locked
  shouldRequoteOnNavigation: (ctx: FlightMachineContext, _event: unknown) =>
    ctx[CartState.cartQuote]?.cartLocked === true,

  // Check if we already have seat selections and can skip re-fetching the seat map
  hasExistingSeatSelections: (ctx: FlightMachineContext, _event: unknown) =>
    ctx[ParentState.seatSelection]?.selectedSeats?.length > 0 &&
    ctx[ParentState.seatSelection]?.seatMapHtml != null,
};
